module.exports = __webpack_public_path__ + "img/photo-veroniquelesourd-accueil-04.837f52f2.jpeg";